import type { ReactNode } from "react";
import { Sidebar } from "./Sidebar.js";
import { ViewAsBar } from "./ViewAsBar.js";

export function AppLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-full overflow-hidden">
      <Sidebar />
      <main
        className="flex-1 flex flex-col overflow-hidden"
        style={{ background: "var(--bg-base)" }}
      >
        <ViewAsBar />
        {children}
      </main>
    </div>
  );
}
